import { isStringEmpty } from './is-string-empty.util';

const regex = /^[a-zA-Z0-9.!#$%&’*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*.[a-zA-Z0-9-]{2,}$/;
export const isValidEmail = (str: string) => {
  if (isStringEmpty(str)) {
    return false;
  }
  return regex.test(str);
};
